var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_656_92",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 20,
    height: 20
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_656_92)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 15.0305,
    width: 20,
    height: 7.4074,
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7.62311,
    width: 20,
    height: 7.4074,
    fill: "#6FB1D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.215759,
    width: 20,
    height: 7.4074,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71094 7.84778V14.5362C6.71094 15.7377 7.18685 16.8153 7.96784 17.608C8.73662 18.3883 9.82268 18.8838 10.9942 18.8838C12.1778 18.8838 13.2517 18.3883 14.0205 17.608C14.8015 16.8153 15.2774 15.7377 15.2774 14.5362V7.84778H6.71094Z",
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37184 8.48373C8.38682 8.63726 8.39206 9.00048 8.2932 9.22515C8.16963 9.506 8.65268 10.7866 9.06833 10.8653C9.40084 10.9282 9.44653 11.2135 9.4278 11.3483C9.76481 10.9027 10.3287 9.87221 9.88838 9.31502C9.67772 9.04847 9.47857 8.8938 9.33754 8.78427C9.11007 8.6076 9.03379 8.54836 9.30423 8.32646C9.74235 7.96698 10.5961 8.66347 10.641 8.98925C10.6609 9.13304 10.7682 9.57447 10.8811 10.0382C10.9168 10.1851 10.953 10.3342 10.9872 10.4768C11.0214 10.3342 11.0577 10.1851 11.0934 10.0382C11.2062 9.57447 11.3136 9.13304 11.3334 8.98925C11.3784 8.66347 12.2321 7.96698 12.6703 8.32646C12.9407 8.54836 12.8644 8.6076 12.6369 8.78427C12.4959 8.8938 12.2968 9.04847 12.0861 9.31502C11.6457 9.87221 12.2097 10.9027 12.5467 11.3483C12.528 11.2135 12.5736 10.9282 12.9062 10.8653C13.3218 10.7866 13.8049 9.506 13.6813 9.22515C13.5824 9.00048 13.5877 8.63726 13.6026 8.48373C14.3682 8.38317 14.5912 9.22515 14.8496 10.3036C15.108 11.382 15.0181 13.1906 14.9058 13.4265C14.8477 13.5483 14.8077 14.0355 14.7702 14.4922C14.735 14.92 14.7021 15.3211 14.6586 15.37C14.5687 15.4711 14.2767 15.2913 14.0969 15.0554C13.9531 14.8667 13.6775 14.1081 13.5577 13.7523C12.8208 13.4737 12.6141 13.0296 12.6029 12.8424C12.3407 13.1682 11.9625 13.8062 12.5467 13.7523C13.2769 13.6849 13.5577 14.3477 13.1308 14.8869C12.7893 15.3183 12.2396 15.1116 12.0075 14.9543C11.7453 14.9019 11.2975 14.8802 11.6031 15.2127C11.985 15.6283 12.5467 17.5718 12.468 17.7627C12.4053 17.9151 11.4588 18.2885 10.9893 18.4578V18.4592L10.9872 18.4585L10.9852 18.4592V18.4578C10.5157 18.2885 9.56917 17.9151 9.50644 17.7627C9.4278 17.5718 9.98949 15.6283 10.3714 15.2127C10.677 14.8802 10.2291 14.9019 9.96702 14.9543C9.73486 15.1116 9.18516 15.3183 8.84365 14.8869C8.41677 14.3477 8.69762 13.6849 9.4278 13.7523C10.012 13.8062 9.63375 13.1682 9.37164 12.8424C9.3604 13.0296 9.1537 13.4737 8.41677 13.7523C8.29695 14.1081 8.02135 14.8667 7.87756 15.0554C7.69782 15.2913 7.40575 15.4711 7.31588 15.37C7.27241 15.3211 7.23945 14.92 7.2043 14.4922C7.16677 14.0355 7.12674 13.5483 7.06874 13.4265C6.9564 13.1906 6.86653 11.382 7.1249 10.3036C7.38328 9.22515 7.60625 8.38317 8.37184 8.48373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37695 10.6504V13.1896C9.37695 13.6478 9.56 14.0566 9.85287 14.3539C10.1457 14.6511 10.5606 14.8369 10.9999 14.8369C11.4514 14.8369 11.8541 14.6511 12.147 14.3539C12.4399 14.0566 12.6229 13.6478 12.6229 13.1896V10.6504H9.37695Z",
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37695 12.3597H10.7559V10.6504H11.244V12.3597H12.6229V12.8551H11.2562V14.8245C11.183 14.8369 11.0976 14.8493 11.0121 14.8493C10.9389 14.8493 10.8535 14.8493 10.7681 14.8245V12.8675H9.37695V12.3597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6235,
    y: 11.045,
    width: 0.69087,
    height: 0.932394,
    rx: 0.345435,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.71924,
    y: 11.045,
    width: 0.69087,
    height: 0.932394,
    rx: 0.345435,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6235,
    y: 13.2412,
    width: 0.69087,
    height: 0.932394,
    rx: 0.345435,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.71924,
    y: 13.2412,
    width: 0.69087,
    height: 0.932394,
    rx: 0.345435,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.79102,
    y: 14.526,
    width: 0.69087,
    height: 1.94904,
    rx: 0.345435,
    transform: "rotate(23.0213 8.79102 14.526)",
    fill: "#F3CE49"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.69087,
    height: 1.94904,
    rx: 0.345435,
    transform: "matrix(-0.92036 0.391073 0.391073 0.92036 13.2593 14.5373)",
    fill: "#F3CE49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.44678,
    y: 8.30276,
    width: 0.970253,
    height: 1.20762,
    rx: 0.485127,
    transform: "rotate(58.5818 9.44678 8.30276)",
    fill: "#F3CE49"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.970253,
    height: 1.20762,
    rx: 0.485127,
    transform: "matrix(-0.52128 0.853386 0.853386 0.52128 12.3706 8.30276)",
    fill: "#F3CE49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62988 4.99027C8.62988 4.43798 9.0776 3.99026 9.62988 3.99026H12.9659C13.5182 3.99026 13.9659 4.43798 13.9659 4.99026V6.05705C13.9659 6.60934 13.5182 7.05705 12.9659 7.05705H9.62988C9.0776 7.05705 8.62988 6.60934 8.62988 6.05705V4.99027Z",
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.62988,
    y: 5.66406,
    width: 5.33599,
    height: 1.39297,
    rx: 0.696487,
    fill: "#F3CE49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSr);
export default __webpack_public_path__ + "static/media/sr.da8d5ac341b156d5aefd93e012789a5c.svg";
export { ForwardRef as ReactComponent };